<template>
    <div
        class="users"
    >
        <list
            :data="{
                list,
                pagination,
                hasLoading,
                headers: [
                    {
                        type: 'component',
                        value: 'contacts',
                        component: () => import( /* webpackChunkName: 'BaseContacts' */ '@/components/bundles/contacts/BaseContacts' )
                    },
                    { type: 'default', value: 'role', isNecessaryTranslate: true },
                    {
                        type: 'component',
                        translate: 'state',
                        value: 'id',
                        component: () => import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' )
                    }
                ],
                destak: 'name'
            }"
        />
        <widget-options />
    </div>
</template>

<script>
// hooks
import { listStructure } from '@/hooks/use-data';

export default {
    ...listStructure
};
</script>